import { ReportTypes } from '@mode/shared/contract-common';
import controller from './filter-panel-controller';

const FilterPanelComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    filters: '<',
    filterOpts: '<',
    optCounts: '<',
    selectedOptCounts: '<',
    model: '<',
    loading: '<',
    onPanelClose: '&?',
    onFiltersApply: '&?',
    onFiltersReset: '&?',
    onFiltersSetDefault: '&?',
    onFilterReset: '&?',
    onFilterDelete: '&?',
    onFilterMoveToBottom: '&?',
    onFilterMoveToPosition: '&?',
    onFilterSetIncludeNulls: '&?',
    onFilterSetSelectControlType: '&?',
    onFilterSetType: '&?',
    orphanedFilters: '<',
    onFilterHideSelectAll: '&?',
  },
  template: `
    <div class="filter-panel-wrap">
      <div class="filter-panel-header">

        <!-- Filter Panel Header Begins -->
        <span class="filter-panel-heading">
          <h3 class="heading">Filters</h3>
        </span>
        <!-- @Filter Panel Header Ends-->

        <!-- Filter Panel Actions Begin -->
        <span ng-if="ctrl.filters.length" class="filter-panel-actions">
          <a href="#" ng-class="{'disabled': !ctrl.isDirty}" ng-click="ctrl.reset($event)" class="filter-panel-action action-reset">Reset</a>
          <a href="#" ng-class="{'disabled': !ctrl.isDirty}" ng-click="ctrl.setDefault($event)" class="filter-panel-action action-set-default">Set as Default</a>
          <capra-button
            text="Apply"
            variant="secondary"
            size="small"
            color="neutral"
            [disabled]="ctrl.loading"
            (clicked)="ctrl.apply($event)"
          ></capra-button>
        </span>
        <!-- @Filter Panel Actions End-->

      </div>

      <div class="filters-container">
        <div ng-if="!ctrl.filters.length && ctrl.showEmptyState" class="empty-filter-module-container">
          <i class="icon-no-filters"></i>
          <p>Add filters to your report by clicking the Add Filter link at the top of the page.</p>
        </div>
        <div ng-if="ctrl.filters.length"
             class="filter-module-container"
             ng-repeat="filter in ctrl.filters"
             ng-class="['control-type-'+filter.controlType.toLowerCase(), 'filter-type-'+filter.filterType.toLowerCase(), 'one-of-' + ctrl.filters.length + '-filters']">
          <!-- Header Begins -->
          <div class="filter-header">
            <span class="filter-heading" ng-attr-title="{{ filter.name }}" ng-bind="filter.name" />
            <i
              class="filter-error"
              ng-if="ctrl.orphanedFilters.has(filter.token)"
              tooltip-append-to-body="true"
              tooltip-class="html-tooltip wrapping-tooltip"
              tooltip-placement="left"
              uib-tooltip-html="ctrl.orphanedFilterTooltip"
            >
              <capra-icon icon="icon-warning"></capra-icon>
            </i>
            <i
              ng-if="ctrl.hasTooManySelected(filter.token)"
              class="filter-warning"
              tooltip-append-to-body="true"
              tooltip-class="html-tooltip wrapping-tooltip"
              tooltip-placement="left"
              uib-tooltip-html="ctrl.tooManySelectionsTooltip"
            >
              <capra-icon icon="icon-warning"></capra-icon>
            </i>
            <i ng-if="ctrl.isFilterCalcField(filter)" class="icon-info"
              uib-tooltip-html="ctrl.calcFieldTooltip"
              tooltip-placement="left"
              tooltip-append-to-body="true"
              tooltip-class="html-tooltip wrapping-tooltip"
            ></i>
            <div uib-dropdown class="filter-context-dropdown context-menu dropdown pull-right">
              <a href="#" uib-dropdown-toggle class="dropdown-toggle">
                <i class="icon-settings-mini"></i>
              </a>
              <ul uib-dropdown-menu dropdown-auto-orient class="filter-context-dropdown-menu dropdown-menu dropdown-menu-right">
                <li class="filter-context-menu-item context-item" ng-class="{selected: filter.filterType === '${ReportTypes.ReportFilterType.Single}'}">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterSetType(filter, '${ReportTypes.ReportFilterType.Single}')"><span class="indicator" ></span>Single-select list</a>
                </li>
                <li class="filter-context-menu-item context-item" ng-class="{selected: filter.filterType === '${ReportTypes.ReportFilterType.Multi}'}">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterSetType(filter, '${ReportTypes.ReportFilterType.Multi}')"><span class="indicator"></span>Multi-select list</a>
                </li>
                <li ng-if="ctrl.showRangeFieldOption(filter)" class="filter-context-menu-item context-item" ng-class="{selected: filter.filterType === '${ReportTypes.ReportFilterType.Range}'}">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterSetType(filter, '${ReportTypes.ReportFilterType.Range}')"><span class="indicator"></span>Range field</a>
                </li>
                <li class="divider context-divider"></li>
                <li ng-if="ctrl.isSelectAllType(filter)"
                  class="filter-context-menu-item context-item" ng-class="{ selected: filter.hideSelectAll !== true }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleSetHideSelectAll(filter)">
                  <span class="indicator"></span>Show "All" in the list</a>
                </li>
                <li ng-if="ctrl.isSelectAllType(filter)" class="divider context-divider"></li>
                <li class="filter-context-menu-item context-item" ng-class="{ 'disabled': ctrl.isTopFilter(filter) }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterMoveUp(filter)">Move up</a>
                </li>
                <li class="filter-context-menu-item context-item" ng-class="{ 'disabled': ctrl.isBottomFilter(filter) }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterMoveDown(filter)">Move down</a>
                </li>
                <li class="filter-context-menu-item context-item" ng-class="{ 'disabled': ctrl.isTopFilter(filter) }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterMoveToTop(filter)">Move to top</a>
                </li>
                <li class="filter-context-menu-item context-item" ng-class="{ 'disabled': ctrl.isBottomFilter(filter) }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterMoveToBottom(filter)">Move to bottom</a>
                </li>
                <li class="divider context-divider"></li>
                <li class="filter-context-menu-item context-item" ng-class="{ 'disabled': !ctrl.isDirtyFilter(filter) }">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterReset(filter)">Reset filter</a>
                </li>
                <li class="divider context-divider"></li>
                <li class="filter-context-menu-item context-item">
                  <a class="filter-context-link context-link" ng-click="ctrl.handleFilterDelete(filter)">Delete</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- @Header Ends -->

          <!-- Body Begins -->
          <div class="filter-body">
            <div ng-if="ctrl.loading">
              <div class="filter-placeholder filter-placeholder-list">
                <div class="list-item-placeholder"></div>
                <div class="list-item-placeholder"></div>
                <div class="list-item-placeholder"></div>
                <div class="list-item-placeholder"></div>
              </div>
              <div class="filter-placeholder filter-placeholder-range">
                <div class="range-start-placeholder"></div>
                <span class="range-separator">–</span>
                <div class="range-end-placeholder"></div>
              </div>
            </div>
            <div ng-if="!ctrl.loading">
              <!-- Single Filter Begins -->
              <filter-module-single
                filter="filter"
                filter-opts="ctrl.filterOpts[filter.token]"
                on-selection="ctrl.handleSingleSelection($filter, $selection)"
                ng-if="filter.filterType === '${ReportTypes.ReportFilterType.Single}'" />
              <!-- @Single Filter Ends -->

              <!-- Multiple Filter Begins -->
              <filter-module-multi
                filter="filter"
                filter-opts="ctrl.filterOpts[filter.token]"
                full-name-tooltip="true"
                on-selection="ctrl.handleMultiSelection($filter, $selection)"
                ng-if="filter.filterType === '${ReportTypes.ReportFilterType.Multi}'" />
              <!-- @Multiple Filter Ends-->

              <!-- Range Filter Begins -->
              <filter-module-range
                filter="filter"
                filter-opts="ctrl.filterOpts[filter.token]"
                on-selection="ctrl.handleRangeSelection($filter, $value)"
                ng-if="filter.filterType === '${ReportTypes.ReportFilterType.Range}'" />
              <!-- Range Filter Ends-->
            </div>
          </div>
          <!-- @Body Ends -->

        <div>
      </div>
    </div>
  `,
};

export { FilterPanelComponent };
